import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { SharedModule } from '../shared/shared.module'
import { AutoCompleteModule } from 'primeng/autocomplete'
import { InputTextModule } from 'primeng/inputtext'
import { DropdownModule } from 'primeng/dropdown'
import { MultiSelectModule } from 'primeng/multiselect'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { ButtonModule } from 'primeng/button'
import { DialogModule } from 'primeng/dialog'
import { CheckboxModule } from 'primeng/checkbox'
import { TreeSelectModule } from 'primeng/treeselect'
import { TooltipModule } from 'primeng/tooltip'
import { ScrollingModule } from '@angular/cdk/scrolling'
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling'
import { OverlayPanelModule } from 'primeng/overlaypanel'
import { SelectButtonModule } from 'primeng/selectbutton'
import { InputNumberModule } from 'primeng/inputnumber'
import { MatIconModule } from '@angular/material/icon'
import { BrowserModule } from '@angular/platform-browser'
import { ProgressBarModule } from 'primeng/progressbar'
import { MatStepperModule } from '@angular/material/stepper'
import { MatRadioModule } from '@angular/material/radio'
import { MatCheckboxModule } from '@angular/material/checkbox'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatInputModule } from '@angular/material/input'
import { MatButtonModule } from '@angular/material/button'
import { MatExpansionModule } from '@angular/material/expansion'
import { NgApexchartsModule } from 'ng-apexcharts'
import { HighchartsChartComponent, provideHighcharts } from 'highcharts-angular'
import { MatTooltipModule } from '@angular/material/tooltip'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { SelectModule } from 'primeng/select'
import { ListboxModule } from 'primeng/listbox'
import { ProgressSpinnerModule } from 'primeng/progressspinner'
import { IconFieldModule } from 'primeng/iconfield'
import { InputIconModule } from 'primeng/inputicon'
import { InputSwitchModule } from 'primeng/inputswitch'
import { AccordionModule } from 'primeng/accordion'
import { MarkdownModule } from 'ngx-markdown'
import { LeaderToolkitDashboardPage } from './pages/dashboard/dashboard-page.component'
import { LeaderToolkitGoalsPage } from './pages/goals/goals-page.component'
import { LeaderToolkitTasksPage } from './pages/tasks/tasks-page.component'
import { LeaderToolkitSchedulingPage } from './pages/scheduling/scheduling-page.component'
import { HeaderRowComponent } from './components/header/header-row.component'
import { RouterModule } from '@angular/router'
import { MatTableModule } from '@angular/material/table'
import { MatPaginatorModule } from '@angular/material/paginator'
import { MatSortModule } from '@angular/material/sort'
import { MatSelectModule } from '@angular/material/select'
import { MatDatepickerModule } from '@angular/material/datepicker'
import { MatNativeDateModule } from '@angular/material/core'
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'
import { CreateNewTaskComponent } from './pages/tasks/create-new-task/create-new-task.component'
import { UploadCsvComponent } from './pages/upload-csv/upload-csv.component'
import { MatDialogModule } from '@angular/material/dialog'
import { LeaderGoalToolkitDetailsComponent } from './pages/goals/leader-goal-toolkit-details/leader-goal-toolkit-details.component'
import { ViewTaskModalComponent } from './pages/tasks/view-task-modal/view-task-modal.component'
import { ReassignTaskModalComponent } from './pages/tasks/reassign-task-modal/reassign-task-modal.component'
import { AssignGoalsModalComponent } from './pages/goals/assign-goals-modal/assign-goals-modal'
import { NewMeetingSchedulerComponent } from './pages/scheduling/new-meeting-scheduler/new-meeting-scheduler.component'
import { OPSDashboardComponent } from './pages/dashboard/ops-dashboard/ops-dashboard.component'
import { HospitalDashboardComponent } from './pages/dashboard/hospital-dashboard/hospital-dashboard.component'
import { HospitalEditorComponent } from './pages/dashboard/hospital-editor/hospital-editor.component'
import {MatTabsModule} from '@angular/material/tabs';
import { UserManagementComponent } from './pages/user-management/user-management.component'
import { CreateUserComponent } from './pages/user-management/create-user/create-user.component'
import { ConfirmationDialogComponent } from './components/confirmation-dialog/confirmation-dialog.component'
import { AssginNewGoalPageComponent } from './pages/goals/assgin-new-goal-page/assgin-new-goal-page.component'
import { MatTimepickerModule } from '@angular/material/timepicker'
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import { MeetingDetailDialogComponent } from './pages/scheduling/meeting-detail-dialog.component'
import {MatChipsModule} from '@angular/material/chips';
import { UserAutocompleteComponent } from './components/user-autocomplete.component'
import { GoalDetailsComponent } from './pages/goals/goal-details/goal-details.component'
import { MomentModule } from 'ngx-moment'
import { NgxEditorModule } from 'ngx-editor'
import { HospitalOpsDashboardComponent } from './pages/dashboard/hospital-ops-dashboard/hospital-ops-dashboard.component'
import { MatMenuModule } from '@angular/material/menu';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { FormatValuePipe } from './components/pipes/goal-value-formating.pipe';
import { GoalFileNamePipe } from './components/pipes/goal-file-name.pipe';
import { RecurrencePreviewDialogComponent } from './pages/tasks/recurrence-preview-dialog.component'
import { SearchResultsPageComponent } from './pages/search/search-results-page.component'
import { HospitalAttentionCardComponent } from './pages/dashboard/hospital-dashboard/components/hospital-attention-card/hospital-attention-card.component'
import { HospitalMeetingsCardComponent } from './pages/dashboard/hospital-dashboard/components/hospital-meetings-card/hospital-meetings-card.component'
import { HospitalNotesCardComponent } from './pages/dashboard/hospital-dashboard/components/hospital-notes-card/hospital-notes-card.component'
import { HospitalTasksCardComponent } from './pages/dashboard/hospital-dashboard/components/hospital-tasks-card/hospital-tasks-card.component'
import { HospitalGoalCardComponent } from './pages/dashboard/hospital-dashboard/components/hospital-goal-card/hospital-goal-card.component'
import { HospitalNextQuarterGoalsComponent } from './pages/dashboard/hospital-dashboard/components/hospital-next-quarter-goals/hospital-next-quarter-goals.component'
@NgModule({
   declarations: [
      LeaderToolkitDashboardPage,
      LeaderToolkitGoalsPage,
      LeaderToolkitTasksPage,
      LeaderToolkitSchedulingPage,
      HeaderRowComponent,
      LeaderGoalToolkitDetailsComponent,
      AssignGoalsModalComponent,
      ViewTaskModalComponent,
      ReassignTaskModalComponent,
      CreateNewTaskComponent,
      UploadCsvComponent,
      NewMeetingSchedulerComponent,
      OPSDashboardComponent,
      HospitalDashboardComponent,
      HospitalEditorComponent,
      UserManagementComponent,
      CreateUserComponent,
      ConfirmationDialogComponent,
      AssginNewGoalPageComponent,MeetingDetailDialogComponent,UserAutocompleteComponent,GoalDetailsComponent,
      HospitalOpsDashboardComponent,
      RecurrencePreviewDialogComponent,
      SearchResultsPageComponent,
      HospitalAttentionCardComponent,
      HospitalMeetingsCardComponent,
      HospitalNotesCardComponent,
      HospitalTasksCardComponent,
      HospitalGoalCardComponent,
      HospitalNextQuarterGoalsComponent,
      GoalFileNamePipe,
      FormatValuePipe
   ],
   imports: [
    CommonModule,
    SharedModule,
    AutoCompleteModule,
    ButtonModule,
    CheckboxModule,
    DialogModule,
    FormsModule,
    DropdownModule,
    MultiSelectModule,
    SelectModule,
    InputTextModule,
    TreeSelectModule,
    TooltipModule,
    ScrollingModule,
    CdkVirtualScrollViewport,
    OverlayPanelModule,
    InputNumberModule,
    SelectButtonModule,
    MatIconModule,
    BrowserModule,
    MatTooltipModule,
    ProgressBarModule,
    MatStepperModule,
    MatRadioModule,
    MatCheckboxModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    MatButtonModule,
    MatExpansionModule,
    NgApexchartsModule,
    HighchartsChartComponent,
    BrowserAnimationsModule,
    ListboxModule,
    ProgressSpinnerModule,
    IconFieldModule,
    InputIconModule,
    InputSwitchModule,
   AccordionModule,
    RouterModule,
    MarkdownModule.forRoot(),
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatSelectModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatDialogModule,
    MatTabsModule,
    MatProgressSpinnerModule,
    MatTimepickerModule, MatAutocompleteModule, MatChipsModule,MomentModule,NgxEditorModule,
    MatMenuModule,
    MatSlideToggleModule
],
   providers: [
      provideHighcharts()
   ]
})
export class LeaderToolkitModule {}
